const styles = {
    paddingTop: '0.5rem',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.4rem',
    alignContent:'center',
    flex:1,
    display:'flex'
}
const headerCss = {
    color: '#777B7E',
    fontFamily: 'workSansSemiBold',
    height: '3vw',
    fontSize: '0.66rem',
    textAlign: 'left',
    paddingLeft: '2rem',
    paddingRight: '2rem',
    letterSpacing: '0.05rem'
}
export const caseOpenStyles = {
    backgroundColor: '#f7931e',
    color: '#ffffff',
    ...styles
}
export const caseReopenedStyles = {
    backgroundColor: '#f15a26',
    color: '#ffffff',
    ...styles
}

export const caseClosedStyles = {
    backgroundColor: '#d5d9e3',
    color: '#0201d5',
    cursor: 'pointer',
    ...styles
}
export const tableCellStyles = {
    paddingLeft: '2rem',
    paddingRight: '2rem',
    fontSize: '1.1rem',
}

export const manageHeaderStyles = {
    ...headerCss,
    textAlign: 'center',
    paddingLeft: '3rem',
    justifyContent: 'center',
    alignItems: 'center',
}

export const headerStyles = {
    ...headerCss,
}

export const searchStyles = {
    marginTop: '-5vw',
    width: '22vw',
    height: '3.2vw',
    border: '1px solid #D0D0D0',
    borderRadius: 3,
    backgroundColor: '#FFFFFF',
    paddingLeft: '5%',
    marginLeft: '2%'
}

export const cellStylesObject = {
    fontFamily: 'hindGunturMedium',
    fontSize: '0.9vw',
    boxShadow: '-0.5px 0px 0px 0px rgba(0,0,0,0.2), 0px -0.5px 0px 0px rgba(0,0,0,0.14), 1px 0px 0px 0px rgba(0,0,0,0.12)',
    maxHeight: '40rem'
}